<template lang="pug">
.announcement-block(
  v-if="announcementBlock.text && announcementBlock.text.trim()"
  :style="containerStyle"
)
  p.announcement-text(:style="textStyle") {{ announcementBlock.text }}
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue';
// eslint-disable-next-line import/no-unresolved, import/extensions
import { AnnouncementBlock as AnnouncementBlockType } from '../types';

export default defineComponent({
  name: 'AnnouncementBlock',
  props: {
    block: {
      type: Object as PropType<AnnouncementBlockType>,
      required: true,
    },
  },
  setup(props) {
    // Computed
    const announcementBlock = computed(() => props.block as AnnouncementBlockType);

    const containerStyle = computed(() => ({
      backgroundColor: announcementBlock.value.textBackgroundColor || '#FBF9F9',
    }));

    const textStyle = computed(() => ({
      color: announcementBlock.value.textColor || '#000000',
    }));

    return {
      announcementBlock,
      containerStyle,
      textStyle,
    };
  },
});
</script>

<style lang="scss" scoped>
@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.announcement-block {
  padding: 20px 24px;
  margin: 0 24px 48px 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.3) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 1000px 100%;
    animation: shimmer 3s infinite;
    pointer-events: none;
  }

  @media (min-width: 768px) {
    padding: 24px 40px;
    margin: 0 40px 56px 40px;
  }

  @media (min-width: 1024px) {
    padding: 28px 64px;
    margin: 0 64px 64px 64px;
  }
}

.announcement-text {
  margin: 0;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
  position: relative;
  z-index: 1;

  @media (min-width: 768px) {
    font-size: 20px;
  }

  @media (min-width: 1024px) {
    font-size: 22px;
  }
}
</style>
